<template>
  <div class="item-detail-picker-options">
    <assignment-picker
      v-if="!hasJobs"
      v-model:selected-id="internalAssigneeID"
      :options="assigneeOptions as IPersonWithEmail[]"
      hide-name
    />
    <status-picker
      v-model:selected-id="internalStatusID"
      :statuses="statusOptions"
      :job-info="jobInfo"
      class="item-detail-picker-options__status-button"
    />
    <priority-picker
      v-model:selected-id="internalPriorityID"
      :options="priorityOptions"
      class="item-detail-picker-options__priority-button"
    />
    <due-date-picker v-model="internalDueDate" />
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { EEntities } from '@/types'
import {
  IPersonBase,
  IPriorityLevelForSelection,
  IStatusForSelection,
  IPersonWithEmail,
} from '@/api/types/response.types'
import { IJobInfo } from '@/types/data-objects/items'

/* API */

export default defineComponent({
  name: 'ItemDetailPickerOptions',

  props: {
    assigneeId: {
      type: Number,
      default: null,
    },
    priorityId: {
      type: Number,
      default: null,
    },
    statusId: {
      type: Number,
      default: null,
    },
    dueDate: {
      type: [Date, String],
      default: null,
    },
    assigneeOptions: {
      type: Array as () => IPersonBase[],
      required: true,
    },
    statusOptions: {
      type: Array as () => IStatusForSelection[],
      required: true,
    },
    priorityOptions: {
      type: Array as () => IPriorityLevelForSelection[],
      required: true,
    },
    jobInfo: {
      type: Object as () => IJobInfo,
      default: null,
    },
  },

  emits: [
    'update:assigneeId',
    'update:dueDate',
    'update:priorityId',
    'update:statusId',
  ],

  data() {
    return {
      EEntities,
    }
  },
  computed: {
    internalAssigneeID: {
      get(): any {
        return this.assigneeId
      },
      set(newValue: any) {
        this.$emit('update:assigneeId', newValue)
      },
    },
    internalPriorityID: {
      get(): any {
        return this.priorityId
      },
      set(newValue: any) {
        this.$emit('update:priorityId', newValue)
      },
    },
    internalStatusID: {
      get(): any {
        return this.statusId
      },
      set(newValue: any) {
        this.$emit('update:statusId', newValue)
      },
    },
    internalDueDate: {
      get(): any {
        return this.dueDate
      },
      set(newValue: any) {
        this.$emit('update:dueDate', newValue)
      },
    },
    hasJobs(): boolean {
      return this.jobInfo !== null
    },
  },
})
</script>

<style lang="scss">
.item-detail-picker-options {
  display: flex;
  align-items: flex-start;
  @include flex-row-horizontal-spacing(8px);
  @include flex-row-vertical-spacing-on-wrap(10px);

  &__status-button,
  &__priority-button {
    .dd-button {
      max-width: 160px;
    }
  }
}
</style>
